<template>
    <vue-good-table
        styleClass="vgt-table bordered"
        theme="polar-bear"
        :line-numbers="true"
        :columns="columns"
        :rows="data"
        :search-options="{
            enabled: true,
            externalQuery: searchTerm
        }"
        :pagination-options="{
            enabled: true,
            perPage:pageLength
        }"
        class="com-details mb-50"
    >
        <template
            slot="table-row"
            slot-scope="props"
        >
            <span v-if="props.column.field === 'shipper'">
                <span v-if="props.row.container.isOwnedByShipper">SOC</span>
                <span v-else>COC</span>
            </span>
        </template>
      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Showing 1 to </span>
            <b-form-select
              v-model="pageLength"
              :options="['3', '5', '10']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
</template>

<script>
import { VueGoodTable } from 'vue-good-table';
import {
  BPagination,
  BFormSelect,
} from "bootstrap-vue";
export default {
    name: "BookingCommodity",
    components: {
        VueGoodTable,
        BPagination,
        BFormSelect,
    },
    props: {
        data: Array
    },
    data() {
        return {
            pageLength: 3,
            rows: [],
            searchTerm: '',
            columns: [
               {
                    label: "Reference",
                    field: 'container.reference',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    label: "Type",
                    field: 'container.containerType',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    label: "Quantity",
                    field: 'container.quantity',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    label: "Weight",
                    field: 'container.weight',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                },
                {
                    label: "Shipper owned container",
                    field: 'shipper',
                    filterOptions: {
                        enabled: true,
                        placeholder: "",
                    },
                }
            ]
        }
    },
    // created() {
    //     console.log("data container",this.data); 
    // }
}
</script>


<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.com-details .vgt-table.polar-bear td {
  padding: .60em 0 .60em 0 !important;
  text-align: center;
  vertical-align: middle !important;
}
.column-desc {
    padding-left: 10px;
    text-align: left !important;
    max-height: 120px;
    overflow-y: auto;
    margin-bottom : 0 !important
}
</style>